// src/utils/pixHelpers.js

/**
 * Retorna o rótulo legível do tipo de chave Pix.
 * CPF → "CPF", EMAIL → "E-mail", PHONE → "Telefone", CNPJ → "CNPJ", EVP/RANDOM → "Aleatória"
 * @param {string|null|undefined} type
 * @returns {string}
 */
export function pixKeyTypeLabel(type) {
  if (!type) return '—';
  switch (type.toUpperCase()) {
    case 'CPF':   return 'CPF';
    case 'CNPJ':  return 'CNPJ';
    case 'EMAIL': return 'E-mail';
    case 'PHONE': return 'Telefone';
    case 'EVP':
    case 'RANDOM': return 'Aleatória';
    default: return type;
  }
}

/**
 * Formata/mascara uma chave Pix conforme o tipo.
 * CPF → "111.222.333-44", CNPJ → "11.222.333/4444-55", PHONE → "+55 (11) 98765-4321"
 * @param {string|null|undefined} key
 * @param {string|null|undefined} type
 * @returns {string}
 */
export function formatPixKey(key, type) {
  if (!key) return '';
  switch (type) {
    case 'CPF':
      return key.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    case 'CNPJ':
      return key.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    case 'PHONE': {
      const clean = key.replace(/\D/g, '');
      if (clean.length === 11) {
        return clean.replace(/(\d{2})(\d{5})(\d{4})/, '+55 ($1) $2-$3');
      }
      if (clean.length === 10) {
        return clean.replace(/(\d{2})(\d{4})(\d{4})/, '+55 ($1) $2-$3');
      }
      return key;
    }
    case 'EMAIL':
    case 'EVP':
    default:
      return key;
  }
}

/**
 * Mascara uma chave Pix para exibicao fora de campos de edicao.
 * @param {string|null|undefined} key
 * @param {string|null|undefined} type
 * @returns {string}
 */
export function maskPixKey(key, type) {
  const raw = String(key || '').trim();
  if (!raw) return '';

  const normalizedType = String(type || '').toUpperCase();
  const digits = raw.replace(/\D/g, '');

  switch (normalizedType) {
    case 'CPF':
      return digits.length >= 11 ? `***.***.***-${digits.slice(-2)}` : maskGeneric(raw);
    case 'CNPJ':
      return digits.length >= 14 ? `**.***.***/****-${digits.slice(-2)}` : maskGeneric(raw);
    case 'PHONE':
      return digits.length >= 4 ? `(**) *****-${digits.slice(-4)}` : maskGeneric(raw);
    case 'EMAIL':
      return maskEmail(raw);
    case 'EVP':
    case 'RANDOM':
      return raw.length > 8 ? `${raw.slice(0, 4)}...${raw.slice(-4)}` : maskGeneric(raw);
    default:
      return maskGeneric(raw);
  }
}

function maskEmail(email) {
  const [localPart, domain] = email.split('@');
  if (!localPart || !domain) return maskGeneric(email);

  const visibleStart = localPart.slice(0, Math.min(2, localPart.length));
  return `${visibleStart}***@${domain}`;
}

function maskGeneric(value) {
  if (value.length <= 4) return '****';
  return `${value.slice(0, 2)}***${value.slice(-2)}`;
}
